/**
 * Webhook Status Constants
 * Centralized status definitions for webhook delivery status
 */

// Webhook status values
export const WEBHOOK_STATUSES = {
  SUCCESS: 'SUCCESS',
  // FAILURE: 'FAILURE',
  // DROP: 'DROP',
  // CANCELLED: 'CANCELLED',
  INITIATED: 'INITIATED',
} as const;

// Export status keys as a type
export type WebhookStatus = keyof typeof WEBHOOK_STATUSES;

// Status groupings for different use cases
export const STATUS_GROUPS = {
  SUCCESSFUL: ['SUCCESS', 'DELIVERED'] as const,
  FAILED: ['FAILURE'] as const,
  PENDING: ['PENDING', 'RETRY'] as const,
} as const;

// Status colors mapping for UI components
export const STATUS_COLORS = {
  SUCCESS: 'success',
  DELIVERED: 'success',
  FAILURE: 'error',
  RETRY: 'warning',
  PENDING: 'warning',
} as const;

// Status display names
export const STATUS_DISPLAY_NAMES = {
  SUCCESS: 'Successful',
  DELIVERED: 'Delivered',
  FAILURE: 'Failed',
  RETRY: 'Retrying',
  PENDING: 'Pending',
} as const;

// Helper functions
export const isSuccessfulStatus = (status: WebhookStatus): boolean => {
  return STATUS_GROUPS.SUCCESSFUL.includes(status as unknown as 'SUCCESS' | 'DELIVERED');
};

export const isFailedStatus = (status: WebhookStatus): boolean => {
  return STATUS_GROUPS.FAILED.includes(status as unknown as 'FAILURE');
};

export const isPendingStatus = (status: WebhookStatus): boolean => {
  return STATUS_GROUPS.PENDING.includes(status as unknown as 'PENDING' | 'RETRY');
};

export const getStatusColor = (status: WebhookStatus): string => {
  return STATUS_COLORS[status] || 'default';
};

export const getStatusDisplayName = (status: WebhookStatus): string => {
  return STATUS_DISPLAY_NAMES[status] || status;
};
